export const USER = 'USER';
export const GAME = 'GAME';
export const SETTINGS = 'SETTINGS';
